<input #input
       matInput
       autocomplete="off"
       class="datex-numberbox {{readOnly ? 'readonly ' : ''}}"
       spellcheck="false"
       title="{{value}}"
       [readonly]="readOnly"
       (focusout)="onFocusOut()"
       [disabled]="disabled"
       (keydown)="onKeyDown($event)">